if (!customElements.get('autoplay-videos')) {
  class AutoplayVideos extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.avs__card'));
      this.fills = this.cards.map((c) => c.querySelector('.avs__progress-fill'));
      this.rafId = null;
      this.active = -1;

      // Wire up ended events before observer fires
      this.cards.forEach((card, i) => {
        const video = card.querySelector('.avs__video');
        if (video) {
          video.addEventListener('ended', () => {
            this.play((i + 1) % this.cards.length);
          });
        }
      });

      // Card click → jump to that video
      this.cards.forEach((card, i) => {
        card.addEventListener('click', () => this.play(i));
      });

      // Dot click → jump to that video
      this.querySelectorAll('.slider-counter__link--dots').forEach((dot, i) => {
        dot.addEventListener('click', () => this.play(i));
      });

      // Start on viewport entry; pause/resume as section leaves/enters
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            if (this.active === -1) {
              this.play(0);
            } else {
              this._resume();
            }
          } else {
            this._pause();
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(this);
    }

    play(index) {
      cancelAnimationFrame(this.rafId);

      // Reset all other cards
      this.cards.forEach((card, i) => {
        const video = card.querySelector('.avs__video');
        card.classList.remove('avs__card--active');
        card.removeAttribute('aria-current');
        if (video && i !== index) {
          video.pause();
          video.currentTime = 0;
        }
        if (this.fills[i]) this.fills[i].style.width = '0%';
      });

      const card = this.cards[index];
      if (!card) return;

      card.classList.add('avs__card--active');
      card.setAttribute('aria-current', 'true');
      this.active = index;

      const video = card.querySelector('.avs__video');
      if (video) {
        video.currentTime = 0;
        video.play().catch(() => {});
        this._animateProgress(video, this.fills[index]);
      }

      this._syncDots(index);
      this._scrollTo(index);
    }

    _pause() {
      cancelAnimationFrame(this.rafId);
      if (this.active < 0) return;
      const video = this.cards[this.active]?.querySelector('.avs__video');
      if (video) video.pause();
    }

    _resume() {
      if (this.active < 0) return;
      const video = this.cards[this.active]?.querySelector('.avs__video');
      if (!video) return;
      video.play().catch(() => {});
      this._animateProgress(video, this.fills[this.active]);
    }

    _animateProgress(video, fill) {
      if (!fill) return;
      const tick = () => {
        if (video.duration) {
          fill.style.width = (video.currentTime / video.duration) * 100 + '%';
        }
        this.rafId = requestAnimationFrame(tick);
      };
      this.rafId = requestAnimationFrame(tick);
    }

    _syncDots(index) {
      this.querySelectorAll('.slider-counter__link--dots').forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('slider-counter__link--active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    _scrollTo(index) {
      const list = this.querySelector('.avs__cards');
      const slides = this.querySelectorAll('.avs__slide');
      const slide = slides[index];
      if (list && slide) {
        list.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }
  }

  customElements.define('autoplay-videos', AutoplayVideos);
}
